import SuccessDomainTransfer from "components/SuccessDomain/SuccessDomainTransfer";
import { useQuery } from "helpers/utils";
import { queryDomainTransfer } from "features/domain/domainsSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { notifyWarning } from "components/ToastMessage";
import { Card, Form, Spinner } from 'react-bootstrap';

const validateDomain = (domainInput, extensionTransfer, setTransferButton) => {
  const kamus = [
    "togel",
    "judi",
    "sex",
    "porn",
    "bugil",
    "bokep",
    "xxx",
    "kontol",
    "casino",
    "kasino",
  ];

  const whitelist = [
    "camillajava",
    "javaleap",
    "unigoldtechnology",
    "livelifebetter",
    "sirajudinhasbi",
    "javapustaka",
    "lajudigital",
    "westjava-shizuoka",
    "betariko",
    "tipjavatransport",
  ];

  const validateSingleDomain = (domainName) => {
    const badWord = kamus.some((str) => domainName.includes(str));
    const whiteWord = whitelist.some((str) => domainName.includes(str));

    if (badWord && !whiteWord) {
      notifyWarning("Domain Anda mengandung kata terlarang!");
      setTransferButton(false);
      return false;
    }

    if (domainName.length < 2) {
      notifyWarning("Nama domain minimal 2 karakter!");
      setTransferButton(false);
      return false;
    }

    if (!domainName) {
      notifyWarning("Domain Anda kosong!");
      setTransferButton(false);
      return false;
    }

    if (!extensionTransfer) {
      notifyWarning("Ekstensi Anda kosong!");
      setTransferButton(false);
      return false;
    }

    if (/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/.test(domainName)) {
      notifyWarning("Domain Anda tidak valid!");
      setTransferButton(false);
      return false;
    }

    return true;
  };

  if (Array.isArray(domainInput)) {
    return domainInput.every((domain) => validateSingleDomain(domain));
  } else {
    return validateSingleDomain(domainInput);
  }
};

const TransferDomain = (props) => {
  const { domainMethod, setDomainMethod, onToggleDomainSections } = props;
  const { status } = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  const query = useQuery();
  const tldRef = useRef();
  const domainTransfer = query.domaintransfer;

  const [extOption, setExtOption] = useState([]);
  const [extension, setExtension] = useState("");
  const [domain, setDomain] = useState("");
  const [transferButton, setTransferButton] = useState(false);

  // Function to handle domain sections toggle
  const handleToggleDomainSections = (shouldShow) => {
    onToggleDomainSections(shouldShow);

    // If showing sections, focus on the domain input after a short delay
    if (shouldShow) {
      setTimeout(() => {
        const domainInput = document.querySelector('input[placeholder="Nama Domain Anda"]');
        if (domainInput) {
          domainInput.focus();
          domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  };

  const searchDomain = (e) => {
    setTransferButton(true);
    e.preventDefault();

    const isValid = validateDomain(domain, extension, setTransferButton);
    if (!isValid) return;

    dispatch(queryDomainTransfer(domain + extension));
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_QWORDS_API}api/domain.php?_type=query`)
      .then((data) => data.json())
      .then((val) => setExtOption(val));
  }, []);

  useEffect(() => {
    if (domainTransfer) {
      const splitDomain = domainTransfer.split(".");
      const domainName = splitDomain[0];
      const extensionTransfer = splitDomain[1];

      const isValid = validateDomain(domainName, extensionTransfer, setTransferButton);
      if (!isValid) return;

      dispatch(queryDomainTransfer(domainTransfer));
    }
  }, [domainTransfer, dispatch, setTransferButton]);

  const options = (props.extOption || []).map(function (option) {
    return { value: option[1], label: option[1], price: option[3] };
  });

  const handleExtension = (e) => {
    if (!e) {
      setExtension("");
      return;
    }
    setExtension(e.value);
  };

  useEffect(() => {
    if (status !== "loading") {
      setTransferButton(false);
    }
  }, [status]);

  const setDomainHandler = (value) => {
    setDomain(value);
  };

  const handleMethodChange = () => {
    setDomainMethod("transfer");
  };

  return (
    <Card className="rounded-4 border-0 shadow-sm mb-4">
      <Card.Body>
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold text-qw-primary mb-0">
                Transfer Domain
              </h5>
            </div>
            
            <div className="form-check py-3 px-4 mb-3" style={{ 
              border: '2px solid #e0e6ed',
              borderRadius: '8px',
              backgroundColor: domainMethod === "transfer" ? '#f8f9fa' : 'transparent'
            }}>
              <div className="d-flex align-items-start ps-2">
                <input
                  type="radio"
                  className="form-check-input me-3"
                  name="domainMethod"
                  id="transferDomain"
                  value="transfer"
                  checked={domainMethod === "transfer"}
                  onChange={handleMethodChange}
                  style={{ marginTop: '2px' }}
                />
                <div className="flex-grow-1">
                  <label
                    htmlFor="transferDomain"
                    className="form-check-label fw-bold d-block"
                  >
                    Transfer domain saya ke Golden Fast Network
                  </label>
                  <p className="mb-0 mt-2 text-muted">
                    Migrasi domainmu dari luar Golden Fast Network ke sini
                  </p>

                  {domainMethod === "transfer" && (
                    <>
                      <form onSubmit={searchDomain} className="mt-3">
                        <div className="row g-3">
                          <div className="col-12 col-md-5">
                            <Form.Control
                              type="text"
                              placeholder="Nama Domain Anda"
                              onChange={(e) => setDomainHandler(e.target.value)}
                              value={domain}
                              style={{ 
                                border: '2px solid #e0e6ed',
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-4">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              onChange={handleExtension}
                              isSearchable={true}
                              name="extensions"
                              options={options}
                              isClearable
                              ref={tldRef}
                              placeholder="Pilih ekstensi..."
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  border: '2px solid #e0e6ed',
                                  borderRadius: '8px',
                                  padding: '4px 8px'
                                })
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-3">
                            <button
                              className="btn btn-cta w-100 rounded-5"
                              type="submit"
                              disabled={transferButton}
                              style={{ 
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            >
                              {transferButton ? (
                                <>
                                  <Spinner animation="border" size="sm" className="me-2" />
                                  Memproses...
                                </>
                              ) : (
                                'Cek Domain'
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                      {(domainTransfer || domainMethod === "transfer") && (
                        <SuccessDomainTransfer
                          extensions={extOption}
                          onToggleDomainSections={handleToggleDomainSections}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TransferDomain;
